import React from 'react';
import './styles.scss';
import TermsConditionsDetails from './TermsConditionsDetails';

const TermsConditions = () => {
    return (
        <div className="center-block terms-conditions">
            <div className="tds-row ls-area article">
                <div id="terms-conditions">
                    <div className="tds-h2--article terms-header">
                        ePHR Web Site Usage Agreement Terms and Conditions and Electronic Delivery
                        Consent
                    </div>
                    <TermsConditionsDetails />
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;
